import { useLang } from '@/i18n';
import React, { useRef } from 'react';

const TextAniA: React.FC<{ pageType: string }> = ({ pageType }) => {
    const { t } = useLang('theProduct.SectionB1');
    const refABox = useRef<any>(null);
    const hasEnterA = useRef<boolean>(false);
    const numA1 = '';
    const numA2 = '';

    const textA =
        pageType === 'ac'
            ? t('text1_ac')
            : t.rich('text1', {
                  text1: (text1: string) => {
                      return <span id="SectionB1-text1-id1">{text1}</span>;
                  },
                  text2: (text2: string) => {
                      return <span id="SectionB1-text1-id2">{text2}</span>;
                  },
              });

    return (
        <>
            <div className="SectionB1-text1" ref={refABox}>
                {textA}
            </div>
        </>
    );
};

export default TextAniA;
